<div class="steps">

<ng-container *ngFor="let step of steps; let i = index; let last = last">

  <div class="step" [ngClass]="{'done': touchedIndex >= i, 'active': index==i, 'invalid': step.invalid }">
    <div (click)="stepClick(i)" class="step-icon">
      <i class="mdi {{step.icon}}"></i>
    </div>
    <div class="step-label">
      {{step.label}}
    </div>
  </div>

  <div *ngIf="!last" class="divider"  [ngClass]="{'active': touchedIndex > i }">
    <div class="divider-progress"></div>
  </div>

</ng-container>

</div>